import { Text } from 'src/modules/shared/components/atoms/text';
import { classes } from 'src/modules/shared/utils/styles.util';
import { isToday } from 'src/utils/date';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

interface DayChipProps {
  date: Date;
}

export const DayChip: React.FC<DayChipProps> = ({ date }) => {
  const { language, t } = useI18n();
  const today = isToday(date);
  const formattedDate = new Intl.DateTimeFormat(language, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).format(date);

  return (
    <div
      className={classes(
        'inline-flex items-center rounded-full bg-white/90 px-4 py-1 text-sm shadow-md backdrop-blur-sm'
      )}
    >
      <Text
        size="small"
        color="secondary"
        className="font-medium text-center whitespace-nowrap"
      >
        {today ? t('shared.date.today') : formattedDate}
      </Text>
    </div>
  );
};
